import { render, staticRenderFns } from "./LanguageControlBox.vue?vue&type=template&id=84e84158&scoped=true"
import script from "./LanguageControlBox.vue?vue&type=script&lang=js"
export * from "./LanguageControlBox.vue?vue&type=script&lang=js"
import style0 from "./LanguageControlBox.vue?vue&type=style&index=0&id=84e84158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e84158",
  null
  
)

export default component.exports